import { Dialog } from "primereact/dialog";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsContractPopupOpened,
} from "src/redux/slices/assignBuildingSlice";
import BuildingContract from "./Contract";
import SystemsPopup from "./SystemsPopup";
import { useTranslation } from "react-i18next";

const ContractPopup = () => {
  const dispatch = useDispatch();
  const { isContractPopupOpened } = useSelector(
    (state: any) => state.assignBuilding
  );

  const { t } = useTranslation(["common", "assignBuilding"]);
  const { isNewMode } = useSelector((state: any) => state.assignBuilding);

  const handleEditProfile = () => {
    dispatch(setIsContractPopupOpened(false) as any);
  };

  return (
    <div>
      <Dialog visible={isContractPopupOpened} onHide={handleEditProfile} header={isNewMode ? t("newContract"):t("editContract")} headerClassName="popup-header" className="edit-assign-building-popup">
        <BuildingContract />
      </Dialog>
      <SystemsPopup></SystemsPopup>
    </div>
  );
};

export default ContractPopup;
